<div class="sidebar">
    <div class="logo">
        <img src="\assets\logos\Logo.png" alt="Logo">
    </div>
    <ul class="modules">
        @for(menuItem of MENU_ITEMS; track $index) {
            <li class="module" [ngClass]="{'selected': menuItem == currentMenuItem}" (click)="clickedMenu(menuItem)">
                <img [src]="menuItem.icon" [alt]="menuItem.label">
                <span class="align-middle">{{menuItem.label}}</span>
            </li>
        }
    </ul>
    <button class="btn border-0" routerLink="/auth/login" (click)="logout()">
        <img src="\assets\icons\logout.svg" alt="logout">
        Cerrar Sesión
    </button>
</div>
